var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCredentials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 7042",
    style: {
      fill: "none"
    },
    d: "M0 0h31v39H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13622"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13621"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18221",
    d: "M618.489 327.776H607a1.775 1.775 0 0 0-1.817 1.728v21.317a1.774 1.774 0 0 0 1.817 1.728h16.55a1.774 1.774 0 0 0 1.817-1.727v-16.213z",
    transform: "translate(-597.368 -323.776)",
    style: {
      strokeWidth: "1.8px",
      strokeMiterlimit: 10,
      stroke: "#5a5a5a",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18222",
    d: "M624.935 334.846h-5.146a1.331 1.331 0 0 1-1.438-1.438v-5.3",
    transform: "translate(-596.953 -323.766)",
    style: {
      strokeWidth: "1.8px",
      strokeMiterlimit: 10,
      stroke: "#5a5a5a",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 64",
    transform: "translate(13.409 10.797)",
    style: {
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      strokeMiterlimit: 10,
      stroke: "#5a5a5a",
      fill: "none"
    },
    d: "M5 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 65",
    transform: "translate(13.387 15.836)",
    style: {
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      strokeMiterlimit: 10,
      stroke: "#5a5a5a",
      fill: "none"
    },
    d: "M8.75 0H0"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13662"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD328\\uC2A4 18223",
    style: {
      strokeLinejoin: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1548.236 731.728.8 5.748-3.732-2.511-3.854 2.511.621-5.748z",
    style: {
      stroke: "none"
    },
    transform: "translate(-1535.954 -702.475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1542.075 731.728-.62 5.748 3.854-2.511 3.732 2.51-.805-5.747h-6.16m0-1.8h6.16a1.8 1.8 0 0 1 1.783 1.55l.805 5.748a1.8 1.8 0 0 1-2.788 1.743l-2.743-1.846-2.856 1.86a1.8 1.8 0 0 1-2.772-1.7l.62-5.749a1.8 1.8 0 0 1 1.79-1.606z",
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    transform: "translate(-1535.954 -702.475)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD0C0\\uC6D0 956",
    style: {
      fill: "#fff",
      strokeWidth: "1.8px",
      stroke: "#5a5a5a"
    },
    transform: "translate(3 19.24)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.1,
    style: {
      fill: "none"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentials);
export default __webpack_public_path__ + "static/media/credentials.2e69a350c19d65006a6a590585a06d5f.svg";
export { ForwardRef as ReactComponent };